const messages = {
  title: "CENOVNICI I BROŠURE PROIZVODA",
  description:
    "Preuzmite najnovije brošure i letke o našim Bridgestone i Firestone gumama za putnička vozila, SUV-ove i kombije ovde.",
  brochureCategories: {
    products: "Proizvodi",
    brand_and_solutions: "Brend i rešenja",
    season_and_promotions: "Sezona i promocije",
    format: "Format",
    cars_and_vans: "Putničko vozilo i kombi",
    summer: "Leto",
    winter: "Zima",
    promotions: "Promocije",
    all_season: "Sve sezone",
    truck_and_buses: "Kamioni i autobusi",
    motorcycle: "Motocikl",
    agriculture: "Poljoprivreda",
    construction_machinery: "Građevinska mašinerija",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materijali",
    brochures: "Brošure proizvoda",
    price_list: "Cenovnici",
    materials: "Materijali",
    video_in_store: "Video sa titlovima",
    video_online: "Video bez titlova",
    banner_website: "Banner",
    banner_social_media: "Društvene mreže",
    logos: "Logoi",
  },
  searchMedia: "Unesite ključnu reč",
  searchResults: "Rezultati pretrage",
};

export default {
  messages,
};
